/* =====================================================================
   INDUCTION HARDWARE — COLLECTION PAGE INTERACTIONS
   Facet collapse, category-rail arrows, mobile filter drawer, and
   auto-submit for sort + (desktop) filter changes. Filtering itself is
   Shopify-native (the forms GET to the collection URL with filter params).
===================================================================== */
(function () {
  var DESKTOP = function () { return window.matchMedia('(min-width: 980px)').matches; };

  /* ---------- Sort: submit on change ---------- */
  document.querySelectorAll('[data-auto-submit]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      if (sel.form) sel.form.submit();
    });
  });

  /* ---------- Filter form ---------- */
  var filterForm = document.querySelector('[data-filters]');
  if (filterForm) {
    // Desktop: apply immediately when a checkbox toggles.
    filterForm.querySelectorAll('[data-filter-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (DESKTOP()) filterForm.submit();
      });
    });
    // Price inputs: debounced submit on desktop.
    var priceT;
    filterForm.querySelectorAll('[data-price]').forEach(function (input) {
      input.addEventListener('input', function () {
        if (!DESKTOP()) return;
        clearTimeout(priceT);
        priceT = setTimeout(function () { filterForm.submit(); }, 600);
      });
    });
  }

  /* ---------- Facet collapse ---------- */
  document.querySelectorAll('[data-facet-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var facet = btn.closest('[data-facet]');
      if (facet) facet.classList.toggle('collapsed');
    });
  });

  /* ---------- Mobile filter drawer ---------- */
  var openBtn = document.querySelector('[data-filter-open]');
  var closeBtn = document.querySelector('[data-filter-close]');
  var scrim = document.querySelector('[data-drawer-scrim]');
  function openDrawer() {
    if (filterForm) filterForm.classList.add('open');
    if (scrim) scrim.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (filterForm) filterForm.classList.remove('open');
    if (scrim) scrim.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (scrim) scrim.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- Category rail arrows ---------- */
  var rail = document.querySelector('[data-cat-rail]');
  var prev = document.querySelector('[data-cat-prev]');
  var next = document.querySelector('[data-cat-next]');
  if (rail && prev && next) {
    var step = function () { return Math.max(rail.clientWidth * 0.8, 240); };
    var sync = function () {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max;
    };
    prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }
})();
